/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFIpAddress } from './CRSFIpAddress';
import {
    CRSFIpAddressFromJSON,
    CRSFIpAddressFromJSONTyped,
    CRSFIpAddressToJSON,
} from './CRSFIpAddress';

/**
 * 
 * @export
 * @interface CRSFIpAddressesPagedResponse
 */
export interface CRSFIpAddressesPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFIpAddressesPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFIpAddressesPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFIpAddress>}
     * @memberof CRSFIpAddressesPagedResponse
     */
    results?: Array<CRSFIpAddress>;
    /**
     * 
     * @type {number}
     * @memberof CRSFIpAddressesPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFIpAddressesPagedResponse interface.
 */
export function instanceOfCRSFIpAddressesPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFIpAddressesPagedResponseFromJSON(json: any): CRSFIpAddressesPagedResponse {
    return CRSFIpAddressesPagedResponseFromJSONTyped(json, false);
}

export function CRSFIpAddressesPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFIpAddressesPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFIpAddressFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFIpAddressesPagedResponseToJSON(value?: CRSFIpAddressesPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFIpAddressToJSON)),
        'total': value.total,
    };
}

